<template>
  <v-container fluid class="settings">
    <v-row class="flex-grow-0">
      <h3>{{ $t("app_drawer.settings") }}</h3>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-0">
      <v-col cols="12">
        <v-btn color="primary" :to="{ name: 'settings-abbreviations' }"
          >{{ $t("abbreviation.title") }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn color="primary" :to="{ name: 'settings-unicode-escapes' }"
          >{{ $t("unicode_escape.title") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="24">
        <div
          style="
            display: flex;
            justify-content: start;
            align-items: center;
            text-align: center;
            margin-bottom: 1rem;
          "
        >
          <v-icon> mdi mdi-auto-fix </v-icon>&nbsp;&nbsp;
          <span>AI Estimation Hint</span>
          <v-switch
            class="ml-2"
            v-model="enable_ai_estimation"
            label="Hide AI Estimation"
            @change="save_show_ai_estimation"
          ></v-switch>
        </div>

        <v-textarea
          outlined
          dense
          hide-details
          auto-grow
          style="background-color: white; color: black"
          v-model="ai_hint"
        ></v-textarea>

        <v-btn color="primary" style="margin-top: 1rem" @click="save_ai_hint"
          >Save Prompt</v-btn
        >

        <v-btn
          color="primary"
          style="margin-top: 1rem; margin-left: 1rem"
          @click="reset_ai_hint"
          >Reset Prompt</v-btn
        >

        <v-snackbar v-model="snackbar" :timeout="2000" color="green" top>
          AI Estimation Hint Save Successfully!
        </v-snackbar>
      </v-col>
    </v-row>
    <v-divider v-if="canEditConfig"></v-divider>
    <v-row v-if="canEditConfig">
      <v-col cols="12">
        <div style="margin-top: 1rem">Configs (Super Admin Only)</div>
        <div
          v-for="(v, i) in superAdminConfig"
          :key="i"
          style="
            margin-top: 1rem;
            display: flex;
            justify-items: center;
            align-items: center;
            gap: 1rem;
          "
        >
          <v-text-field
            filled
            :label="v.key"
            hide-details="auto"
            style="max-width: 20rem"
            v-model="v.value"
          ></v-text-field>
          <v-btn color="primary" @click="() => saveSuperAdminConfig(v)">
            <v-icon>mdi mdi-content-save</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { onMounted, ref, computed } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import { USER_TYPE } from "@/constants";
export default {
  name: "Settings",
  setup(props, { root }) {
    const ai_hint = ref("");
    const enable_ai_estimation = ref(false);
    const snackbar = ref(false);
    const superAdminConfig = ref([]);
    const canEditConfig = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.SUPER_ADMIN].includes(root.$store.getters.account.type);
    });

    const get_ai_hint = async () => {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/ai/get_prompt_hits/",
          params: {},
        });

        if (response.body.success && response.body.prompt) {
          ai_hint.value = response.body.prompt.prompt;
          enable_ai_estimation.value = response.body.prompt.enable;
        }
      } catch (e) {
        console.log(e);
      }
    };

    const save_ai_hint = async () => {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/ai/edit_default_prompt_hits/",
          params: {
            prompt: ai_hint.value,
          },
        });

        if (response.body.success && response.body.prompt) {
          ai_hint.value = response.body.prompt.prompt;
          snackbar.value = true;
        }
      } catch (e) {
        console.log(e);
      }
    };

    const save_show_ai_estimation = async () => {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/ai/enable_ai_estimation/",
          params: {
            enable: enable_ai_estimation.value,
          },
        });

        if (response.body.success && response.body.prompt) {
          enable_ai_estimation.value = response.body.prompt.enable;
        }
      } catch (e) {
        console.log(e);
      }
    };

    const reset_ai_hint = async () => {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/ai/reset_default_prompt_hits/",
          params: {},
        });

        if (response.body.success && response.body.prompt) {
          ai_hint.value = response.body.prompt.prompt;
          snackbar.value = true;
        }
      } catch (e) {
        console.log(e);
      }
    };

    const get_super_admin_only_config = async () => {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/settings/get_super_admin_only_config/",
          params: {},
        });

        if (response.body.success && response.body.all_settings) {
          superAdminConfig.value = response.body.all_settings;
        }
      } catch (e) {
        console.log(e);
      }
    };

    const saveSuperAdminConfig = async (config) => {
      if (canEditConfig) {
        try {
          const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
            url: "admin/settings/edit_super_admin_only_system_config/",
            params: {
              ...config,
            },
          });

          if (response.body.success) {
            get_super_admin_only_config();
            root.$store.dispatch(ACTION_TYPES.SHOW_SNACKBAR, {
              message: `Update Success`,
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    };

    onMounted(() => {
      get_ai_hint();
      get_super_admin_only_config();
    });
    return {
      snackbar,
      ai_hint,
      get_ai_hint,
      save_ai_hint,
      reset_ai_hint,
      canEditConfig,
      superAdminConfig,
      saveSuperAdminConfig,
      enable_ai_estimation,
      save_show_ai_estimation,
    };
  },
};
</script>

<style lang="less">
.settings {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
